import React, { useState, useEffect, useRef } from "react";
import { Modal, Icon, List, Collapse } from "antd";
import axios from "axios";

import { useNotification } from "../../../../shared/hooks/useNotification";

const { Panel } = Collapse;

const ModalProcessarAulas = ({ visible, processoId, onClose }) => {
    const [semanas, setSemanas] = useState([]);

    const timeoutRef = useRef(null);

    const notify = useNotification();

    const processarAulas = () => {
        axios({
            method: "get",
            url: "/api/aulas/lote-status",
            params: {
                processoId
            }
        })
            .then(response => {
                const semanasFormatadas = (response.data?.semanasProcessadas ?? []).map(semana => ({
                    titulo: semana.semana,
                    status: semana.status,
                    totalAulasCriadas: semana.aulasCriadas,
                    totalAulas: semana.totalAulas,
                    aulas: semana.falhas.map(falha => ({
                        disciplina: falha.disciplina,
                        data: `${falha.dia} ${falha.hora}`,
                        motivos: falha.motivos
                    }))
                }));

                setSemanas(semanasFormatadas);

                if (response.data?.status === "Completed") {
                    return;
                }

                timeoutRef.current = setTimeout(processarAulas, 500);
            })
            .catch(error => {
                const msg = error?.response?.data || error?.message || "Ocorreu um erro inesperado. Por favor, tente novamente.";

                notify.error("Erro", msg);
                onClose();
                return;
            });
    };

    const renderStatusIcon = status => {
        switch (status) {
            case "Completed":
                return <Icon type="check-circle" style={{ color: "#84bd00", fontSize: 20 }} />;

            case "Processing":
                return <Icon type="loading" style={{ fontSize: 20 }} />;

            case "Parcial":
                return <Icon type="exclamation-circle" style={{ color: "#faad14", fontSize: 20 }} />;

            case "Failed":
                return <Icon type="close-circle" style={{ color: "#ff4d4f", fontSize: 20 }} />;

            default:
                return null;
        }
    };

    const renderResumo = () => {};

    useEffect(() => {
        if (processoId) {
            processarAulas();

            return () => {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
            };
        }
    }, [processoId]);

    const totalAulas = semanas.reduce((soma, item) => {
        return soma + item.totalAulas;
    }, 0);

    const totalStatus = semanas.reduce((acc, item) => {
        const key = item.status.toLowerCase();

        if (!acc[key]) acc[key] = 0;

        acc[key] += 1;

        return acc;
    }, {});

    return (
        <Modal
            title={`Processar aulas por semana (${totalAulas} aulas em ${semanas.length} semanas)`}
            visible={visible}
            onOk={() => {}}
            onCancel={onClose}
            footer={null}
            width={600}
            className="modal-processar-lote-aulas"
        >
            <div className="modal-processar-lote-aulas-body">
                <div className="aulas-lote-resumo">
                    <span>Semanas: </span>
                    <span>
                        <Icon type="check-circle" style={{ color: "#84bd00" }} />
                        {totalStatus.completed || 0} criadas
                    </span>
                    <span>
                        <Icon type="exclamation-circle" style={{ color: "#faad14" }} />
                        {totalStatus.parcial || 0} avisos
                    </span>
                    <span>
                        <Icon type="close-circle" style={{ color: "#ff4d4f" }} />
                        {totalStatus.failed || 0} erros
                    </span>
                </div>
                <List
                    className="lista-semanas"
                    dataSource={semanas}
                    renderItem={semana => (
                        <List.Item>
                            <div style={{ width: "100%" }}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: "100%"
                                    }}
                                >
                                    <span className="semana-titulo">{semana.titulo}</span>
                                    <span
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px"
                                        }}
                                    >
                                        {semana.totalAulasCriadas}/{semana.totalAulas} aulas {renderStatusIcon(semana.status)}
                                    </span>
                                </div>
                                {semana.aulas?.length > 0 && (
                                    <div className="lista-aulas">
                                        <div className="semana-subtitulo">Aulas não criadas (clique para detalhes): </div>
                                        <Collapse
                                            defaultActiveKey={[]}
                                            expandIcon={({ isActive }) => <Icon type="caret-right" rotate={isActive ? 90 : 0} />}
                                        >
                                            {semana.aulas.map((aula, index) => (
                                                <Panel header={`${aula.disciplina} (${aula.data})`} key={index}>
                                                    <div>
                                                        <label>Motivos:</label>
                                                        {aula.motivos.map((motivo, idx) => (
                                                            <div key={idx} style={{ marginLeft: "20px" }}>
                                                                - {motivo}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Panel>
                                            ))}
                                        </Collapse>
                                    </div>
                                )}
                            </div>
                        </List.Item>
                    )}
                />
            </div>
        </Modal>
    );
};

export default ModalProcessarAulas;
